/**
 * Fraud detection thresholds for address and barcode comparison
 *
 * These values are tuned based on OCR accuracy:
 * - ADDRESS_SIMILARITY: 80% allows for minor OCR errors in street names
 * - ZIP_SIMILARITY: 100% stricter because zip codes are shorter and more critical
 * - BARCODE_SIMILARITY: 90% allows for 2-3 character OCR errors in long tracking numbers
 *   (Tesseract OCR can misread similar characters like 0/O, 1/I, 8/B, 5/S)
 */
export const FRAUD_DETECTION_THRESHOLDS = {
  ADDRESS_SIMILARITY: 0.8,
  ZIP_SIMILARITY: 1,
  BARCODE_SIMILARITY: 0.9,
} as const
